import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useStyles } from '../../pages/EventReview/style'

interface GoToSectionButtonProps {
  link: string
}

export const GoToSectionButton = ({ link }: GoToSectionButtonProps) => {
  const navigate = useNavigate()
  const classes = useStyles()

  return (
    <Button 
      className={classes.goToSectionButton} 
      variant='outlined' 
      onClick={() => {
        navigate(link)
      }}
    >
      Go to Section
    </Button>
  )
} 